// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see CustomerEngagementClickReportEvent
 */
export var CustomerEngagementClickReport = function (_a) {
    var channel = _a.channel, metadataId = _a.metadataId, url = _a.url, additionalData = _a.additionalData;
    return ({
        name: "CustomerEngagement Click Report",
        parameters: {
            cdf_entity: "CustomerEngagement",
            cdf_action: "Click",
            channel: channel !== undefined && channel !== null ? channel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            metadata_id: metadataId !== undefined && metadataId !== null ? metadataId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            url: url !== undefined && url !== null ? url.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            additional_data: additionalData !== undefined && additionalData !== null ? additionalData.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
